import { InlineComposer, type ComposerDrawerPayload, type ComposerMode } from '../shared/timeline/InlineComposer';
import { usePartnerComposerSaves } from './usePartnerComposerSaves';

export interface PartnerComposerHostProps {
  partnerId: string;
  pipelineContext?: string;
  onSaved: () => void | Promise<void>;
  onOpenDrawer: (mode: ComposerMode, payload: ComposerDrawerPayload) => void;
}

/**
 * Task 5 "Partner drawer unificato": gemello di `LeadComposerHost.tsx` per il composer
 * inline della cronologia di un PARTNER. Stessa ragione d'essere (regole degli hook: non
 * si può chiamare `usePartnerComposerSaves` in modo condizionale dentro
 * `LeadNotesSection`), stessa forma (`InlineComposer` + `onSaveNote`/`onSaveActivity`).
 *
 * `LeadNotesSection` sceglie QUALE dei due host montare in base a `entityType`: qui la
 * nota finisce su `deal_notes.partner_id` e l'attività su `sales_activities.partner_id`
 * (via `usePartnerComposerSaves`, Task 1) — MAI su `lead_id`.
 */
export function PartnerComposerHost({ partnerId, pipelineContext, onSaved, onOpenDrawer }: PartnerComposerHostProps) {
  const saves = usePartnerComposerSaves({ partnerId, pipelineContext });

  return (
    <InlineComposer
      onSaveNote={async (html) => {
        await saves.saveNote(html);
        await onSaved();
      }}
      onSaveActivity={async (input) => {
        await saves.saveActivity(input);
        await onSaved();
      }}
      onOpenDrawer={onOpenDrawer}
    />
  );
}

export default PartnerComposerHost;
